/**
 * [pug template]
 */
<template lang="pug">
  div
    .olst-field-checkbox-label
      label.olst-field-checkbox-label-group(:for="name", v-text="getFilterName", @click="labelClicked", :class="{ 'olst-field-checkbox-label-group-open': hideFilters }")
    div
      div(v-show="!hideFilters", v-for="checkbox, index in checkboxes", :class="{ 'olst-checkbox-all checkbox-check-all': checkbox.isAllCheckbox, 'olst-checkbox': !checkbox.isAllCheckbox }")
        input(type="checkbox", :name="checkbox.key", :id="checkbox.key", :value="checkbox.key", v-model="checkedCheckboxed" @change="checkbox.onClick(checkbox.key)")
        label.olst-field-checkbox-label.olst-field-checkbox-label-item(:for="checkbox.key", v-text="checkbox.label")
      .olst-clear

</template>
/**
 * [javascript application]
 */
<script>
import checkboxLib from '../../../../lib/common/checkbox'

export default {
  name: 'multiple-choice',
  props: {
    filter: {
      type: Object,
      default: { label: '', values: [] }
    },
    name: {
      type: String,
      default: ''
    },
    withAll: {
      type: Boolean,
      default: true
    },
    bigArea: {
      type: Boolean,
      default: false
    },
    hideFilters: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      checkboxes: [],
      checkedCheckboxed: []
    }
  },
  components: {},
  created: function () {
    /* Ajout du bouton all */
    if (this.withAll) {
      this.checkboxes.push({
        label: 'Tout',
        key: this.name + '-all',
        onClick: this.toggleAll,
        isAllCheckbox: true
      })
    }
    for (var index in this.filter.values) {
      this.checkboxes.push({
        label: this.filter.values[index].label,
        key: this.filter.values[index].value,
        onClick: this.selectOne,
        isAllCheckbox: false
      })
    }
    for (index in this.checkboxes) {
      this.checkedCheckboxed.push(this.checkboxes[index].key)
    }
  },
  computed: {
    getFilterName: function () {
      return 'Filtrer par ' + this.filter.label
    }
  },
  methods: {
    /**
     * Informe le clic du label
     */
    labelClicked: function () {
      this.$emit('label-clicked', { name: this.name })
    },
    /**
     * Sélectionne toutes les checkbox
     */
    toggleAll: function () {
      this.checkedCheckboxed = checkboxLib.toggleAll(this.checkboxes, this.checkedCheckboxed, this.checkboxes[0])
    },
    /**
     * Sélectionne une checkbox
     */
    selectOne: function (name) {
      this.checkedCheckboxed = checkboxLib.toggleOneCheckbox(this.checkboxes, this.checkedCheckboxed.slice(0), this.checkboxes[0], name)
    },
    /**
     * Vérifie si la checkbox est cochée
     * @param {Object} checkbox L'objet checkbox
     * @return {Boolean}
     */
    isCheckboxChecked: function (checkbox) {
      return (this.checkedCheckboxed.indexOf(checkbox.key) !== -1)
    }
  },
  watch: {
    /**
     * Watcher sur l'attribut "checkedCheckboxed"
     * @param {String} newValue La nouvelle valeur
     * @param {String} oldValue L'ancienne valeur
     */
    checkedCheckboxed: function (newValue, oldValue) {
      var dataEmit = {}

      dataEmit[this.name] = { newValue: newValue }
      this.$emit('value-changed', dataEmit)
    }
  }
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// CheckboxListWithAllOption.vue?63c74e21